import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent {
  @Input() message: any;
  @Input() actionText?: string;
  @Input() iconImg?: string;
  @Input() allowClose: boolean = false;
  @Output() closeBanner = new EventEmitter();
  @Output() performAction = new EventEmitter();
}
